import {BaseOptions} from "../../../../dialog/options/base.options";

export class AddOrUpdateAttributeOptions extends BaseOptions {
  attribute?: any;

  onInsertOrUpdateFinished() {
  }
}
